import { c as _c } from "react/compiler-runtime";
import * as React from 'react';
import type { BreadcrumbsProps as MuiBreadcrumbsProps } from '@mui/material/Breadcrumbs';
import MuiBreadcrumbs from '@mui/material/Breadcrumbs';
import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';
import { mergeSx } from '@/lib/mergeSx';
import { urlForCmsLink } from '@/lib/urlForCmsLink';
import type { CmsBreadcrumbLink } from '@/services/cms/models/CmsBreadcrumbLink';
export interface BreadcrumbsProps extends MuiBreadcrumbsProps {
  breadcrumbs?: CmsBreadcrumbLink[];
  variant?: 'dark' | 'light';
}
export function Breadcrumbs(t0) {
  const $ = _c(17);
  let breadcrumbs;
  let props;
  let sx;
  let t1;
  let t2;
  if ($[0] !== t0) {
    ({
      breadcrumbs,
      variant: t1,
      sx,
      separator: t2,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = breadcrumbs;
    $[2] = props;
    $[3] = sx;
    $[4] = t1;
    $[5] = t2;
  } else {
    breadcrumbs = $[1];
    props = $[2];
    sx = $[3];
    t1 = $[4];
    t2 = $[5];
  }
  const variant = t1 === undefined ? "dark" : t1;
  const separator = t2 === undefined ? "\u203A" : t2;
  if (!breadcrumbs?.length) {
    return;
  }
  let t3;
  if ($[6] !== sx || $[7] !== variant) {
    t3 = mergeSx({
      ...(variant === "light" ? {
        "--mui-palette-text-secondary": "var(--mui-palette-grey-100)"
      } : {})
    }, sx);
    $[6] = sx;
    $[7] = variant;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== breadcrumbs || $[10] !== variant) {
    t4 = breadcrumbs?.map((breadcrumb, i) => <BreadcrumbItem key={i} variant={variant} current={i === breadcrumbs.length - 1} breadcrumb={{
      ...breadcrumb,
      link: breadcrumb.link
    }} />);
    $[9] = breadcrumbs;
    $[10] = variant;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== props || $[13] !== separator || $[14] !== t3 || $[15] !== t4) {
    t5 = <MuiBreadcrumbs separator={separator} aria-label="breadcrumb" sx={t3} {...props}>{t4}</MuiBreadcrumbs>;
    $[12] = props;
    $[13] = separator;
    $[14] = t3;
    $[15] = t4;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  return t5;
}
interface BreadcrumbItemProps {
  breadcrumb: CmsBreadcrumbLink;
  current?: boolean;
  variant?: 'dark' | 'light';
}
function BreadcrumbItem(t0) {
  const $ = _c(13);
  const {
    breadcrumb,
    current,
    variant
  } = t0;
  if (current) {
    const t1 = variant === "light" ? "grey.100" : "text.primary";
    let t2;
    if ($[0] !== t1) {
      t2 = {
        color: t1,
        py: 1.37,
        display: "inline-block"
      };
      $[0] = t1;
      $[1] = t2;
    } else {
      t2 = $[1];
    }
    let t3;
    if ($[2] !== breadcrumb.title || $[3] !== t2) {
      t3 = <Typography variant="caption" sx={t2}>{breadcrumb.title}</Typography>;
      $[2] = breadcrumb.title;
      $[3] = t2;
      $[4] = t3;
    } else {
      t3 = $[4];
    }
    return t3;
  }
  const t1 = variant === "light" ? "secondary.main" : undefined;
  let t2;
  if ($[5] !== t1) {
    t2 = {
      color: t1,
      typography: "caption",
      py: 1.37,
      display: "inline-block"
    };
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== breadcrumb.link) {
    t3 = urlForCmsLink(breadcrumb.link);
    $[7] = breadcrumb.link;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== breadcrumb.title || $[10] !== t2 || $[11] !== t3) {
    t4 = <Link underline="hover" sx={t2} color="primary" href={t3}>{breadcrumb.title}</Link>;
    $[9] = breadcrumb.title;
    $[10] = t2;
    $[11] = t3;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  return t4;
}